import { Paper, styled } from '@mui/material';

export const Wrap = styled(Paper)({
	display: 'flex',
	flexDirection: 'column',
	gap: '8px',
	height: 'fit-content',
	overflow: 'hidden',

	padding: '8px',
});

export const TitleWrap = styled(Paper)({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	padding: '14px 16px',
});
